<template>
  <upload v-bind="$attrs" :uploadType="{ ...uploadType, action }" @successCBK="successCBK" />
</template>
<script>
import Upload from '@/components/Upload';

export default {
  components: { Upload },
  name: 'cUpload',
  props: {
    action: {
      required: true
    }
  },
  data() {
    return {
      uploadType: {
        isActon: true
      }
    };
  },
  methods: {
    successCBK(value) {
      this.$emit('successCBK', value);
    }
  }
};
</script>
